import { Row, Col, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { FaEdit, FaFolderPlus } from "react-icons/fa";

const ProgramsCard = ({program}) => {
  let history = useHistory();
  return (
    <Row>
      <Col className="">
        <div className="program-card rounded shadow mb-4 p-3 ">
          <Row>
            <Col md={2}>
              <img src="https://via.placeholder.com/150" alt="img" className="img-fluid rounded" />
            </Col>
            <Col md={8}>
              <h5>{program.name}</h5>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua.
              </p>
            </Col>
            <Col md={2} className="text-end">
              <div className="m-2">
                <Button size="sm" variant="outline-primary" onClick={() => {
                  history.push(`/build/${program.id}`)
                }}>
                  <FaEdit size="1em" className="m-2" />
                  Edit
                </Button>
              </div>
              <div className="m-2">
                <Button size="sm" variant="outline-primary">
                  <FaFolderPlus size="1em" className="m-2" />
                  Assign
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ProgramsCard;
